import { Form, Formik } from 'formik'
import { observer } from 'mobx-react-lite'
import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import axiosService from '../../../../../utils/AxiosService'
import Input from '../../../../FormComponents/Input'
import Textarea from '../../../../FormComponents/Textarea'
import { toastError, toastSuccess } from '../../../../FormComponents/Toasts'
import Modal from '../../../../Modal/Modal'

export default observer(function DescriptionModal({ authentication, setIsOpen, isOpen }) {
  const { id } = useParams()
  const [currentTimeout, setCurrentTimeout] = useState(null)
  const [isAiLoading, setIsAiLoading] = useState(false)

  const handleSubmit = ({ description }) => {
    axiosService.patch(`/api/project_manager/authentications/${id}`, { authentication: { description } })
    .then(updatedAuthentication => {
      authentication.description = updatedAuthentication.description
      toastSuccess('Description updated successfully')
      setIsOpen(false)
    })
    .catch(({ data: { error } }) => toastError(error))
  }

  const handleAiGenerate = (setFieldValue, extra) => {
    if (isAiLoading) return
    setIsAiLoading(true)
    setFieldValue('description', (prev) => prev)
    axiosService.post(`/api/project_manager/authentications/${id}/generate_description`, { extra })
      .then(({ description }) => {
        setFieldValue('description', description)
        toastSuccess('AI description generated')
      })
      .catch((err) => {
        const error = err?.data?.error || 'AI generation failed'
        toastError(error)
      })
      .finally(() => setIsAiLoading(false))
  }

  return (
    <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <Modal.Header>Edit Description</Modal.Header>
      <Modal.Body>
        <div className="w-half-screen">
          <Formik
            initialValues={{
              description: authentication.description,
            }}
            onSubmit={handleSubmit}
          >
            {({ handleBlur, handleChange, values, setFieldValue, isSubmitting }) => (
              <Form>
                <div className="form-item-container w-full">

                  <Textarea rows={10} label="Description" placeholder="Description" name='description' onChange={handleChange} onBlur={handleBlur} value={values.description} />
                  <div className="flex gap-3 mb-4 items-end">
                    <div className="flex-1">
                      <Input label="AI extra prompt" name="ai_extra" placeholder="E.g., focus: lifestyle; short CTA." onChange={handleChange} onBlur={handleBlur} value={values.ai_extra || ''} />
                    </div>
                    <button
                      type="button"
                      onClick={() => handleAiGenerate(setFieldValue, values.ai_extra)}
                      disabled={isAiLoading}
                      className={`px-5 py-2 rounded-full border-2 whitespace-nowrap self-end ${isAiLoading ? 'border-gray-300 text-gray-400 cursor-not-allowed' : 'border-rb-green text-rb-green'}`}
                    >{isAiLoading ? 'AI…' : 'AI'}</button>
                  </div>
                  <button
                    type="submit"
                    className="submit text-left w-full text-rb-green border-2 rounded-full w-60 py-4 text-center active:shadow-outer active:shadow-rb-green border-rb-green"
                  >
                    Update
                  </button>

                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  )
})